import { Check, Info, X } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@shigo-ui/ui';

import { dashboardT } from '../../../../../lib/messages';
import {
  ReportDeliveryFrequency,
  savedReportUserLabel,
  type SavedReportConfig,
  type ScheduledReportConfig,
} from '../../model';

export function SharedWithInfo({ report }: { report: SavedReportConfig }) {
  if (!report.sharedWith.length) return <span>-</span>;
  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>
        <button
          type="button"
          className="text-muted-foreground hover:text-foreground inline-flex cursor-help"
          aria-label={dashboardT('savedReports.sharedWith')}
        >
          <Info className="h-4 w-4" aria-hidden="true" />
        </button>
      </TooltipTrigger>
      <TooltipContent className="max-w-80 whitespace-pre-line">
        {report.sharedWith.map(savedReportUserLabel).join('\n')}
      </TooltipContent>
    </Tooltip>
  );
}

export function ScheduleInfo({ schedule }: { schedule?: ScheduledReportConfig | undefined }) {
  if (!schedule) {
    return (
      <X
        className="text-destructive mx-auto h-4 w-4"
        aria-label={dashboardT('savedReports.notScheduled')}
      />
    );
  }
  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>
        <button
          type="button"
          className="text-success inline-flex cursor-help"
          aria-label={dashboardT('savedReports.scheduled')}
        >
          <Check className="h-4 w-4" aria-hidden="true" />
        </button>
      </TooltipTrigger>
      <TooltipContent className="max-w-96 whitespace-pre-line">
        {`${dashboardT('savedReports.recipients')}\n${schedule.recipients.join('\n')}\n\n${dashboardT(
          'savedReports.frequency',
        )}\n${frequencyLabel(schedule)}`}
      </TooltipContent>
    </Tooltip>
  );
}

function frequencyLabel(schedule: ScheduledReportConfig) {
  if (schedule.deliveryFrequency === ReportDeliveryFrequency.Daily) {
    return dashboardT('savedReports.schedule.daily');
  }
  if (schedule.deliveryFrequency === ReportDeliveryFrequency.Weekly) {
    return dashboardT('savedReports.schedule.weekly');
  }
  return dashboardT('savedReports.schedule.monthly');
}
